import { render, staticRenderFns } from "./KeyThirtyFive.vue?vue&type=template&id=9db70258&scoped=true&"
import script from "./KeyThirtyFive.vue?vue&type=script&lang=js&"
export * from "./KeyThirtyFive.vue?vue&type=script&lang=js&"
import style0 from "./KeyThirtyFive.vue?vue&type=style&index=0&id=9db70258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db70258",
  null
  
)

export default component.exports